import axios from 'axios'

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'https://onboarding-api.simplewealth.ch/prod',
    headers:{
        "Content-Type": "application/json"
    }
})

export default api